import { buildModelManager } from "../builder.js";
const DefaultExperimentAssignmentSelection = {
  __typename: true,
  id: true,
  assignedAt: true,
  country: true,
  createdAt: true,
  deviceType: true,
  experimentId: true,
  sessionId: true,
  shopId: true,
  updatedAt: true,
  userAgent: true,
  variantId: true,
  visitorId: true
};
const modelApiIdentifier = "experiment_assignment";
const pluralModelApiIdentifier = "experiment_assignments";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultExperimentAssignmentSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultExperimentAssignmentSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultExperimentAssignmentSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultExperimentAssignmentSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultExperimentAssignmentSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultExperimentAssignmentSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultExperimentAssignmentSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createExperimentAssignment",
    operationReturnType: "CreateExperimentAssignment",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      experiment_assignment: { required: false, type: "CreateExperimentAssignmentInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultExperimentAssignmentSelection
  },
  {
    type: "action",
    operationName: "bulkCreateExperimentAssignments",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateExperimentAssignmentsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultExperimentAssignmentSelection
  },
  {
    type: "action",
    operationName: "updateExperimentAssignment",
    operationReturnType: "UpdateExperimentAssignment",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      experiment_assignment: { required: false, type: "UpdateExperimentAssignmentInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultExperimentAssignmentSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateExperimentAssignments",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateExperimentAssignmentsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultExperimentAssignmentSelection
  },
  {
    type: "action",
    operationName: "deleteExperimentAssignment",
    operationReturnType: "DeleteExperimentAssignment",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteExperimentAssignments",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertExperimentAssignment",
    operationReturnType: "UpsertExperimentAssignment",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      experiment_assignment: { required: false, type: "UpsertExperimentAssignmentInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateExperimentAssignmentResult": { hasReturnType: false },
      "... on UpdateExperimentAssignmentResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultExperimentAssignmentSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertExperimentAssignments",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertExperimentAssignmentsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultExperimentAssignmentSelection
  }
];
const ExperimentAssignmentManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultExperimentAssignmentSelection,
  operations
);
export {
  DefaultExperimentAssignmentSelection,
  ExperimentAssignmentManager
};
//# sourceMappingURL=ExperimentAssignment.js.map
